import {Routes} from "@angular/router";
import {OwnerRoutes} from "./_models/_enums/owner-routes";
import {IntegrationsComponent} from "./integrations/integrations.component";
import {PlatformComponent} from "./platform/platform.component";
import {AuthGuard} from "../../_auth/auth.guard";
import {PermissionService} from "../../_auth/permission.service";
import {ContractManagerComponent} from "./contract-manager/contract-manager.component";
import {CompanyOverviewComponent} from "./company-overview/company-overview.component";
import {CompanyCreateComponent} from "./company-create/company-create.component";
import {ShardEditComponent} from "./shard-edit/shard-edit.component";
import {AccountAdministrationComponent} from "./account-administration/account-administration.component";
import {OwnerLegalComponent} from "./legal/owner-legal.component";

export const OWNER_ROUTES: Routes = [
  {
    path: OwnerRoutes.Integrations,
    component: IntegrationsComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.owner.default},
    title: "Integrationen"
  },
  {
    // Same PlatformOwner gate as its neighbours: every value on it is installation-wide, so there is no tenant
    // a company-scoped role could be confined to.
    path: OwnerRoutes.Platform,
    component: PlatformComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.owner.default},
    title: "Plattform"
  },
  {
    path: OwnerRoutes.ContractManager,
    component: ContractManagerComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.owner.default},
    title: "Vertragsmanager"
  },
  {
    // The gate is the same PlatformOwner set as its neighbours, and it has to be: the screen enumerates every
    // account on the installation and resets a credential on one by bare id, with no tenant to confine a
    // company-scoped role to.
    path: OwnerRoutes.AccountAdministration,
    component: AccountAdministrationComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.owner.default},
    title: "Konten"
  },
  {
    path: OwnerRoutes.CompanyOverview,
    component: CompanyOverviewComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.owner.default},
    title: "Unternehmensübersicht"
  },
  {
    path: OwnerRoutes.CompanyCreate,
    component: CompanyCreateComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.owner.default},
    title: "Unternehmensassistent"
  },
  {
    // Rechtliches (#613/#631). The same PlatformOwner gate as its neighbours, and it has to be: every
    // control on it is owner-only server-side (`[DynamicAuthorize("Legal", MetaRole.Owner)]`) and the page
    // names any shard on the installation by id, so there is no tenant a company-scoped role could be
    // confined to. A `ShardAdmin` reaches the READ-ONLY tenant pages under `/legal/…` instead.
    path: OwnerRoutes.Legal,
    component: OwnerLegalComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.owner.default},
    title: "Rechtliches"
  },
  {
    path: OwnerRoutes.ShardEdit,
    component: ShardEditComponent,
    canActivate: [AuthGuard],
    data: {roles: PermissionService.owner.default},
    title: "Shardassistent"
  },
  {
    path: '**', redirectTo: '/', pathMatch: 'full'
  }
];
